/* import __COLOCATED_TEMPLATE__ from './class-group-miaa-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ClassGroupMiaaPointsCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroup = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			this.calculateRacePoints();
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	async savePoints()
	{
		if(this.classGroup && this.selectedRacePts != null)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
		await this.calculateTeamScores();
		
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedRacePts != null)
		{
			const results = (await this.classGroup.get('results')).slice();
			//sort by team
			results.sort(this.teamSort);
			//check each team for 4 valid starters
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}
			const teams = [];
			for(const team of teamNames)
			{
				teams.push({name:team,count:0});
			}
			//count valid staters for each team
			for(const result of results)
			{
				if(result.status == "OK"||result.status=="DNF"||result.status=="DSQ")
				{
					for(const team of teams)
					{
						if(team.name == result.club)
						{
							team.count++;
						}
					}
				}
			}
			//mark teams as validforpoints
			for(const result of results)
			{
				result.validForPoints = false;
				for(const team of teams)
				{
					if(team.name == result.club)
					{
						if(team.count >3 && result.status == "OK")
						{
							result.validForPoints = true
						}
					}
				}
			}
			//sort by time
			results.sort(this.placeSort)
			//sort by school
			results.sort(this.teamSort);
			//mark 7th+ skiers for no points, and exclude teams with fewer than 4 starters
			let currentTeam = "";
			let teamCount = 0;
			for(const result of results)
			{
				if(result.club != currentTeam)
				{
					currentTeam = result.club;
					teamCount = 0;
				}
				// Check if team has at least 4 starters
				const team = teams.find(t => t.name == result.club);
				const teamEligible = team && team.count >= 4;

				if(teamEligible && teamCount < 6 && result.status == "OK")
				{
					result.validForPoints = true;
					teamCount++;
				}
				else
				{
					result.validForPoints = false;
				}
			}
			//sort by time
			results.sort(this.placeSort)
			//assign points
			let currentPoints = 1;
			let tiePoints = 1;
			for(const result of results)
			{
				if(result.validForPoints)
				{
					if(result.isTie)
					{
						result.calculatedRacePoints = tiePoints;
						currentPoints++;
					}
					else
					{
						result.calculatedRacePoints = currentPoints;
						currentPoints++;
						tiePoints = currentPoints;
					}
				}
				else
				{
					result.calculatedRacePoints = 0;
				}
			}
		}
	}
	
	async calculateTeamScores()
	{
		if(this.classGroup && this.selectedRacePts != null)
		{
			const results = (await this.classGroup.get('results')).slice();

			// Filter to only results with points (exclude 0s) and sort by points (ascending)
			const scoringResults = results
				.filter(r => r.calculatedRacePoints > 0)
				.sort((a, b) => a.calculatedRacePoints - b.calculatedRacePoints);

			// Sort by team
			scoringResults.sort(this.teamSort);

			// Collect all the teams
			const teamNames = [];
			for(const result of scoringResults)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}

			// Build team results
			const teamResults = [];
			teamResults.push([
				"Team", "Score 1", "Score 2", "Score 3", "Score 4", "Total"
			]);

			for(const teamName of teamNames)
			{
				let count = 0;
				let sum = 0;
				const scores = [];

				// Sort this team's results by points to get top 4
				const teamScoringResults = scoringResults
					.filter(r => r.club == teamName)
					.sort((a, b) => a.calculatedRacePoints - b.calculatedRacePoints);

				for(const result of teamScoringResults)
				{
					if(count < 4)
					{
						sum += result.calculatedRacePoints;
						scores.push(result.calculatedRacePoints);
						count++;
					}
				}

				teamResults.push([
					teamName,
					scores[0] || "",
					scores[1] || "",
					scores[2] || "",
					scores[3] || "",
					sum
				]);
			}

			// Sort by total (ascending - lower is better)
			const header = teamResults.shift();
			teamResults.sort((a, b) => a[5] - b[5]);
			teamResults.unshift(header);

			this.csv.export(teamResults, {fileName: 'teamResults-' + this.classGroup.name + '.csv', withSeparator: false});
		}
	}
	
	get resultsSorted()
	{
		if(this.classGroup == null || this.selectedRacePts == null)
		{
			return []
		}
		return this.classGroup.get('results');//.then((rs) => (rs.slice().sort(this.pursuitSort)));
	}
	
	teamSort(a,b)
	{
		const aClub = a.club || "";
		const bClub = b.club || "";
		return aClub.localeCompare(bClub);
	}
	placeSort(a,b)
	{
		return a.place-b.place;
	}
}